// Die Feldliste der Suche vom Server (ST-SEA-002, „PQL S3“; CM-SEA-010).
//
// Einmal je Anmeldung und Adresse abgerufen und in felder.ts uebernommen.
// Scheitert der Abruf, bleibt Fassung 1 stehen: die Suche funktioniert
// weiter, nur neue Aliase des Servers fehlen dann. Darum keine Meldung.

import type { SendLike } from '../command-client.ts';
import { uebernimmFeldliste } from './abfrage/felder.ts';

export interface ServerFeld {
  readonly key: string;
  readonly label: string;
  readonly aliases: readonly string[];
  readonly multiValued: boolean;
  readonly openValues: boolean;
}

/** Liest die Antwort defensiv: eine kaputte Zeile faellt weg, statt die Liste zu verderben. */
export function parseFeldliste(payload: unknown): readonly ServerFeld[] | undefined {
  const fields = (payload as { fields?: unknown } | undefined)?.fields;
  if (!Array.isArray(fields)) return undefined;
  return fields.flatMap((row): ServerFeld[] => {
    const feld = row as Record<string, unknown>;
    const aliases = feld['aliases'];
    if (
      typeof feld['key'] !== 'string' ||
      typeof feld['label'] !== 'string' ||
      !Array.isArray(aliases) ||
      !aliases.every((alias) => typeof alias === 'string') ||
      typeof feld['multiValued'] !== 'boolean' ||
      typeof feld['openValues'] !== 'boolean'
    ) {
      return [];
    }
    return [{ key: feld['key'], label: feld['label'], aliases: aliases as string[], multiValued: feld['multiValued'], openValues: feld['openValues'] }];
  });
}

let geladenFuer: string | undefined;

/** Holt die Feldliste einmal je Adresse und Anmeldung; jeder Fehler laesst Fassung 1 stehen. */
export async function feldlisteLaden(options: { readonly baseUrl: string; readonly accessToken: string; readonly send?: SendLike | undefined }): Promise<boolean> {
  const schluessel = `${options.baseUrl} ${options.accessToken}`;
  if (geladenFuer === schluessel) return true;
  const send = options.send ?? fetch;
  try {
    const response = await send(`${options.baseUrl}/party-search-fields`, { headers: { authorization: `Bearer ${options.accessToken}` } });
    if (!response.ok) return false;
    const felder = parseFeldliste(await response.json());
    if (felder === undefined) return false;
    uebernimmFeldliste(felder);
    geladenFuer = schluessel;
    return true;
  } catch {
    return false;
  }
}
